<template>
  <router-view />
</template>

<script>
export default {
  name: "Docs"
}
</script>

<style scoped>

</style>